<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";

import gender from "../../../helpers/list/gender";
import marital_status from "../../../helpers/list/marital_status";
import city from "../../../helpers/list/city";

import Job_title from "../../../helpers/list/Job_title";
import level from "../../../helpers/list/educational_level";
import certificate from "../../../helpers/list/certificate";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      name1: "",
      name2: "",
      name3: "",
      name4: "",

      family_name: "",
      birth_date: "",
      gender_id: "",
      phone1: "",
      marital_status_id: "",

      certificate_id: "",
      university: "",
      college: "",
      level_id: "",
      job: "",

      city_id: "",
      district: "",
      current_place: "",
      nearest_point: "",

      //lists
      list_gender: gender,
      list_marital_status: marital_status,
      list_city: city,
      list_Job_title: Job_title,
      list_level: level,
      list_certificate: certificate,
    };
  },
  validations: {
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },

    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    birth_date: { required },
    gender_id: { required },

    phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
    marital_status_id: { required },

    job: { required },
    certificate_id: { required },
    level_id: {
      required: requiredIf(function () {
        return this.getCertificateStatus();
      }),
    },
    university: {
      required: requiredIf(function () {
        return this.getCertificateStatus();
      }),
      minLength: minLength(3),
      maxLength: maxLength(100),
    },
    college: {
      required: requiredIf(function () {
        return this.getCertificateStatus();
      }),
      minLength: minLength(3),
      maxLength: maxLength(100),
    },

    city_id: { required },
    district: { required, minLength: minLength(2), maxLength: maxLength(50) },
    current_place: { required, minLength: minLength(2), maxLength: maxLength(50) },
    nearest_point: { required, minLength: minLength(2), maxLength: maxLength(50) },

    form: [
      "name1",
      "name2",
      "name3",
      "name4",
      "family_name",
      "birth_date",
      "gender_id",
      "phone1",
      "marital_status_id",
      "city_id",
      "district",
      "current_place",
      "nearest_point",
      "job",
      "certificate_id",
      "university",
      "college",
      "level_id",
    ],
  },
  methods: {
    // validate
    validate() {
      // alert(this.$v);
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    // getCertificateStatus
    getCertificateStatus() {
      return (
        this.certificate_id == "8" ||
        this.certificate_id == "9" ||
        this.certificate_id == "10" ||
        this.certificate_id == "11" ||
        this.certificate_id == "12"
      );
    },

    // getCertificateInstitute
    getCertificateInstitute() {
      return this.certificate_id == "8";
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات المتقدم الاساسية</h5></div>

      <div class="col-md-12">
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
            <b-form-input
              id="name1"
              type="text"
              placeholder="ادخل الاسم"
              v-model="name1"
              :class="{ 'is-invalid': $v.name1.$error }"
            ></b-form-input>
            <div v-if="$v.name1.$error" class="invalid-feedback">
              <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name1.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
            <b-form-input
              id="name2"
              type="text"
              placeholder="ادخل اسم الاب"
              v-model="name2"
              :class="{ 'is-invalid': $v.name2.$error }"
            ></b-form-input>
            <div v-if="$v.name2.$error" class="invalid-feedback">
              <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name2.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
            <b-form-input
              id="name3"
              type="text"
              placeholder="ادخل اسم الجد"
              v-model="name3"
              :class="{ 'is-invalid': $v.name3.$error }"
            ></b-form-input>
            <div v-if="$v.name3.$error" class="invalid-feedback">
              <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name3.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
            <b-form-input
              id="name4"
              type="text"
              placeholder="ادخل اسم اب الجد"
              v-model="name4"
              :class="{ 'is-invalid': $v.name4.$error }"
            ></b-form-input>
            <div v-if="$v.name4.$error" class="invalid-feedback">
              <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name4.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name4.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
            <b-form-input
              id="family_name"
              type="text"
              placeholder="ادخل اللقب"
              v-model="family_name"
              :class="{ 'is-invalid': $v.family_name.$error }"
            ></b-form-input>
            <div v-if="$v.family_name.$error" class="invalid-feedback">
              <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
              <span v-if="!$v.family_name.minLength"
                >يجب أن يتكون اللقب من حرفين على الأقل</span
              >
              <span v-if="!$v.family_name.maxLength"
                >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="تاريخ التولد : "
            label-for="birth_date"
          >
            <date-picker
              id="birth_date"
              type="date"
              lang="ar"
              value-type="DD-MM-YYYY"
              format="DD-MM-YYYY"
              placeholder="اختر تاريخ التولد"
              v-model="birth_date"
              :class="{ 'is-invalid': $v.birth_date.$error }"
            ></date-picker>
            <div v-if="$v.birth_date.$error" class="invalid-feedback">
              <span v-if="!$v.birth_date.required">هذا الحقل الزامي </span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label=" الجنس : " label-for="gender_id">
            <select
              class="form-control form-select"
              id="gender_id"
              v-model="gender_id"
              :class="{ 'is-invalid': $v.gender_id.$error }"
            >
              <option value="">اختر الجنس</option>
              <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                {{ gender.name }}
              </option>
            </select>
            <div v-if="$v.gender_id.$error" class="invalid-feedback">
              <span v-if="!$v.gender_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label=" رقم الهاتف : " label-for="phone1">
            <b-form-input
              id="phone1"
              type="number"
              placeholder="ادخل رقم الهاتف"
              v-model="phone1"
              :class="{ 'is-invalid': $v.phone1.$error }"
            ></b-form-input>
            <div v-if="$v.phone1.$error" class="invalid-feedback">
              <span v-if="!$v.phone1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.phone1.minLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
              >
              <span v-if="!$v.phone1.maxLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-4 mb-3"
            label=" الحالة الاجتماعية : "
            label-for="marital_status_id"
          >
            <select
              class="form-control form-select"
              id="marital_status_id"
              v-model="marital_status_id"
              :class="{ 'is-invalid': $v.marital_status_id.$error }"
            >
              <option value="">اختر الحالة الاجتماعية</option>
              <option
                v-for="marital_status in list_marital_status"
                :value="marital_status.id"
                :key="marital_status.id"
              >
                {{ marital_status.name }}
              </option>
            </select>
            <div v-if="$v.marital_status_id.$error" class="invalid-feedback">
              <span v-if="!$v.marital_status_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3" label=" العمل : " label-for="job">
            <select
              class="form-control form-select"
              id="job"
              v-model="job"
              :class="{ 'is-invalid': $v.job.$error }"
            >
              <option value="">اختر العمل</option>
              <option
                v-for="Job_title in list_Job_title"
                :value="Job_title.id"
                :key="Job_title.id"
              >
                {{ Job_title.name }}
              </option>
            </select>
            <div v-if="$v.job.$error" class="invalid-feedback">
              <span v-if="!$v.job.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label=" التحصيل الدراسي : "
            label-for="certificate_id"
          >
            <select
              class="form-control form-select"
              id="certificate_id"
              v-model="certificate_id"
              :class="{ 'is-invalid': $v.certificate_id.$error }"
            >
              <option value="">اختر التحصيل الدراسي</option>
              <option
                v-for="certificate in list_certificate"
                :value="certificate.id"
                :key="certificate.id"
              >
                {{ certificate.name }}
              </option>
            </select>
            <div v-if="$v.certificate_id.$error" class="invalid-feedback">
              <span v-if="!$v.certificate_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>
        <div class="row" v-if="getCertificateStatus()">
          <b-form-group
            class="col-md-4 mb-3"
            :label="getCertificateInstitute() ? 'المعهد :' : 'الجامعة :'"
            label-for="university"
          >
            <b-form-input
              id="university"
              type="text"
              :placeholder="
                getCertificateInstitute() ? 'ادخل اسم المعهد' : 'ادخل اسم الجامعة'
              "
              v-model="university"
              :class="{ 'is-invalid': $v.university.$error }"
            ></b-form-input>
            <div v-if="$v.university.$error" class="invalid-feedback">
              <span v-if="!$v.university.required">هذا الحقل الزامي</span>
              <span v-if="!$v.university.minLength"
                >يجب أن تتكون الجامعة من ثلاثة احرف على الأقل</span
              >
              <span v-if="!$v.university.maxLength"
                >يجب أن تتكون الجامعة من 100 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            :label="getCertificateInstitute() ? 'القسم/الفرع :' : 'الكلية/القسم/الفرع :'"
            label-for="college"
          >
            <b-form-input
              id="college"
              type="text"
              :placeholder="
                getCertificateInstitute()
                  ? 'ادخل القسم والفرع'
                  : 'ادخل الكلية والقسم والفرع'
              "
              v-model="college"
              :class="{ 'is-invalid': $v.college.$error }"
            ></b-form-input>
            <div v-if="$v.college.$error" class="invalid-feedback">
              <span v-if="!$v.college.required">هذا الحقل الزامي</span>
              <span v-if="!$v.college.minLength"
                >يجب أن تتكون الكلية من ثلاثة احرف على الأقل</span
              >
              <span v-if="!$v.college.maxLength"
                >يجب أن تتكون الكلية من 100 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label=" المرحلة الدراسية : "
            label-for="level_id"
          >
            <select
              class="form-control form-select"
              id="level_id"
              v-model="level_id"
              :class="{ 'is-invalid': $v.level_id.$error }"
            >
              <option value="">اختر المرحلة الدراسية</option>
              <option v-for="level in list_level" :value="level.id" :key="level.id">
                {{ level.name }}
              </option>
            </select>
            <div v-if="$v.level_id.$error" class="invalid-feedback">
              <span v-if="!$v.level_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>

        <div class="row">
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">عنوان السكن</h5></div>
          <b-form-group class="col-md-3 mb-3" label=" المحافظة  : " label-for="city_id">
            <select
              class="form-control form-select"
              id="city_id"
              v-model="city_id"
              :class="{ 'is-invalid': $v.city_id.$error }"
            >
              <option value="">اختر المحافظة</option>
              <option v-for="city in list_city" :value="city.id" :key="city.id">
                {{ city.name }}
              </option>
            </select>
            <div v-if="$v.city_id.$error" class="invalid-feedback">
              <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="القضاء : " label-for="district">
            <b-form-input
              id="district"
              type="text"
              placeholder="ادخل القضاء"
              v-model="district"
              :class="{ 'is-invalid': $v.district.$error }"
            ></b-form-input>
            <div v-if="$v.district.$error" class="invalid-feedback">
              <span v-if="!$v.district.required">هذا الحقل الزامي</span>
              <span v-if="!$v.district.minLength"
                >يجب أن تتكون القضاء من حرفين على الأقل</span
              >
              <span v-if="!$v.district.maxLength"
                >يجب أن تتكون القضاء من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="مكان الاقامة الحالي : "
            label-for="current_place"
          >
            <b-form-input
              id="current_place"
              type="text"
              placeholder="ادخل مكان الاقامة الحالي"
              v-model="current_place"
              :class="{ 'is-invalid': $v.current_place.$error }"
            ></b-form-input>
            <div v-if="$v.current_place.$error" class="invalid-feedback">
              <span v-if="!$v.current_place.required">هذا الحقل الزامي</span>
              <span v-if="!$v.current_place.minLength"
                >يجب أن يتكون مكان الاقامة الحالي من حرفين على الأقل</span
              >
              <span v-if="!$v.current_place.maxLength"
                >يجب أن يتكون مكان الاقامة الحالي من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="اقرب نقطة دالة : "
            label-for="nearest_point"
          >
            <b-form-input
              id="nearest_point"
              type="text"
              placeholder="ادخل اقرب نقطة دالة"
              v-model="nearest_point"
              :class="{ 'is-invalid': $v.nearest_point.$error }"
            ></b-form-input>
            <div v-if="$v.nearest_point.$error" class="invalid-feedback">
              <span v-if="!$v.nearest_point.required">هذا الحقل الزامي</span>
              <span v-if="!$v.nearest_point.minLength"
                >يجب أن تتكون اقرب نقطة دالة من حرفين على الأقل</span
              >
              <span v-if="!$v.nearest_point.maxLength"
                >يجب أن تتكون اقرب نقطة دالة من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
